import React from 'react';
import PropTypes from 'prop-types';
import { AlertDialog, Flex, Text } from '@homeexchange/design';
import i18n from '../../../i18n';
import { connect } from 'react-redux';
import User from '../../../models/User';

const ResumeDialog = ({ isOpen, onConfirm, onDelete, user }) => {
    return (
        <AlertDialog
            title={i18n.t('collection:modal.applicationCollection.applicationResume.title')}
            confirmActionText={i18n.t('collection:global.continueApplication')}
            dismissActionText={i18n.t('collection:global.cancelApplication')}
            isOpen={isOpen}
            onConfirmAction={onConfirm}
            onDismissAction={onDelete}
        >
            <Flex>
                <Text>
                    {i18n.t('collection:modal.applicationCollection.applicationResume.body', {
                        value: user?.get('first_name') ? user?.get('first_name') : ''
                    })}
                </Text>
            </Flex>
        </AlertDialog>
    );
};

ResumeDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    user: PropTypes.instanceOf(User)
};

const mapStateToProps = (state) => ({
    user: state.user
});

export default connect(mapStateToProps)(ResumeDialog);
